
import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({filters})
export default class UploadProgress extends Vue {
  /* VUEX */

  /* PROP */
  @Prop({ default: "uploadProgress" })
  private id: string;
  @Prop({ default: "Document.xls" })
  private filename: string;
  @Prop({ default: 0 })
  private filesize: number;
  @Prop({ default: false })
  private isOnProgress: boolean;
  @Prop({
    default: () => {
      //
    },
  })
  private cancel: () => void;

  /* INITIALIZATION */

  constructor() {
    super();
  }

  /* METHOD */

  private clickDestory() {
    $(`#${this.id}`).remove();
    this.$destroy();
    if (this.cancel instanceof Function) {
      this.cancel();
    }
  }
}
